import { render, staticRenderFns } from "./LearnHabitatGoals.vue?vue&type=template&id=d8beb552&scoped=true&"
import script from "./LearnHabitatGoals.vue?vue&type=script&lang=js&"
export * from "./LearnHabitatGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8beb552",
  null
  
)

export default component.exports